import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, isRef as _isRef, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"padding":"20px 0"} }

import { t } from '@/plugins/i18n'
import CommonDialog from '@/components/common/CommonDialog.vue'
import { computed, ref } from 'vue'
import { ElMessage } from 'element-plus'

export default /*#__PURE__*/_defineComponent({
  props: ['visible', 'showJp', 'showKr', 'showZh'],
  emits: ['update:visible', 'success'],
  setup(__props, { emit: emits }) {

const props = __props



const show = computed(() => {
  return props.visible
})
const countryCode = ref('CN')
const ok = () => {
  if (!countryCode.value) {
    ElMessage.warning('请选择要批量设置的商品')
    return
  }
  emits('success', countryCode.value)
  cancel()
}
const cancel = () => {
  countryCode.value = 'CN'
  emits('update:visible', false)
}

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CommonDialog, {
      visible: _unref(show),
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_isRef(show) ? (show).value = $event : null)),
      title: _unref(t)('请选择要批量设置的商品'),
      onOk: ok,
      onCancel: cancel,
      footer: true,
      width: 400
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_radio_group, {
            modelValue: countryCode.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((countryCode).value = $event))
          }, {
            default: _withCtx(() => [
              (__props.showZh)
                ? (_openBlock(), _createBlock(_component_el_radio, {
                    key: 0,
                    label: "CN"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('中国仓库商品')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (__props.showKr)
                ? (_openBlock(), _createBlock(_component_el_radio, {
                    key: 1,
                    label: "KR"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('韩国仓库商品')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (__props.showJp)
                ? (_openBlock(), _createBlock(_component_el_radio, {
                    key: 2,
                    label: "JP"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('日本仓库商品')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ]))
}
}

})